<template>
	<modal
		:key="computedKey"
		v-if="model.sendReportTo"
		class="signature-modal"
		:show.sync="modalActive">
		<template slot="header">
			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label>Manda documento a:</label>
						<el-select
							v-if="site"
							size="large"
							@change="computedKey++"
							v-model="model.sendReportTo.contact"
							input-class="form-control-lg form-control"
							filterable
							placeholder="Seleziona la fase">
								<el-option
									:value="null"
									label="Nessuno (solo a italmotori)"
									:key="'noone'"
									/>
								<el-option
									v-for="option in site.emails"
									:value="option._id"
									:label="option.contactName"
									:key="option._id"
								/>
								<el-option
									:key="'other'"
									:value="'other'"
									label="Altro"
									/>
						</el-select>
					</div>
				</div>
				<div
					v-if="model.sendReportTo.contact === 'other'"
					class="col-12 col-md-6"
					>
					<base-input
						label="Email contatto"
						v-validate="'required'"
						:error="getError('sendNewContactMail')"
						v-model="model.sendReportTo.newContact.email"
						name="sendNewContactMail"
						type="email"
						input-size="form-control-lg"
						placeholder="Email" />
				</div>
				<div
					v-if="model.sendReportTo.contact === 'other'"
					class="col-12 col-md-6"
					>
					<base-input
						label="Nome contatto"
						v-validate="'required'"
						:error="getError('sendNewContactName')"
						v-model="model.sendReportTo.newContact.contactName"
						name="sendNewContactName"
						type="text"
						input-size="form-control-lg"
						placeholder="Inserisci nome contatto" />
				</div>
			</div>
		</template>
		<div>
			<div class="p-3">
			</div>
			
			<div
				v-if="model.sendReportTo.contact !== null"
				class="signature-main"
			>
				<label class="pl-3 pr-3 font-weight-bold">Firma cliente</label>
				<VueSignaturePad
					class="signature-container"
					width="667px"
					save-type="image/svg+xml"
					height="230px"
					ref="signaturePad"
				/>
				<!--div>
					<button class="btn btn-danger" @click="clear">Cancella</button>
				</div-->
			</div>
		</div>
		<template slot="footer">
			<base-button
				type="primary"
				class="m-auto"
				@click="saveSignature"
				native-type="submit">
    			<i class="icon-cloud-upload-94 tim-icons" />
				Salva e invia report
			</base-button>
		</template>
	</modal>
</template>
<style lang="scss">
	.signature-modal {
		overflow: auto;
		.modal-dialog{
			max-width: 100%;
			width: 667px;
			@media only screen and (max-width : 767px){
				transform: none !important;
			}
			@media only screen and (min-width : 768px) and (max-width : 1200px){
				transform: none !important;
			}
		}
		.modal-content{
			overflow: auto;
		}
		.modal-body{
			padding: 0;
		}
		.signature-main{
			position: relative;
			overflow: hidden;
			margin-bottom: 15px;
		}
		.signature-container{
			background: #ddd;
			@media only screen and (orientation : portrait) and (max-width : 767px){
				min-height: 62px;
				top: 20px;
				left: 0;
				background: none;
				// max-width: 100%;
				margin-bottom: -30%;
				// height: auto !important;
				canvas{
					transform-origin: 0 0;
					transform: scale(0.5);
					opacity: 0.8;
				}
				&:after{	
					display: flex;
					justify-content: center;
					align-items: center;
					background: rgba(#ddd,0.1);
					position: absolute;
					top: 0;
					right: 0;
					left:0;
					bottom: 0;
					padding: 40px 15px;
					font-weight: 600;
					font-size: 22px;
					text-align: center;
					color: #666;
					content:"Gira il telefono per scrivere";
				}
			}
		}
		.signature-demand-landscape{
			display: none;
			background: #ddd;
			padding: 40px 15px;
			font-weight: 500;
			font-size: 24px;
			text-align: center;
			color: #999;
			@media only screen and (orientation : portrait) and (max-width : 767px){
				display: block;
			}
		}
	}
</style>
<script>
	import {Modal} from 'src/components'
	import VueSignaturePad from 'vue-signature-pad';
	import { Select, Option } from 'element-ui'

	export default {
		components: {
			Modal,
			[Option.name]: Option,
			[Select.name]: Select,
			VueSignaturePad
		},
		name: 'revision-technical-signature',
		props:{
			site: Object,
			model: Object,
			submit: Function,
			show: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			clear() {
				this.$refs.signaturePad.clearSignature();
			},
			saveSignature() {
				if (this.model.sendReportTo.contact !== null){
					const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
					if (!isEmpty){ // TODO VALIDAZIONE FIRMA
						this.model.signature = data;
						this.submit()
						this.$router.push(`/sites/${this.site.id}/engines/${this.$route.params.engineId}`)
					}
				}else{
					this.submit()
					this.$router.push(`/sites/${this.site.id}/engines/${this.$route.params.engineId}`)
				}
			},
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
		},
		mounted(){
			//quando apro questo componente devo assicurarmi che la vista si refreshi in modo da fare ripartire il campo della firma
			this.computedKey++;
		},
		watch: {
			show(newValue) {
				this.modalActive = newValue;
			}
		},
		data() {
			return {
				computedKey: 0,
				modalActive: this.show,
			}
		}
	}
</script>